import {useQuery} from "react-query";
import getPromise from "./getPromise";
import {ajax_url} from "../routes/AnimalSpeciesList_Route";

const prefix_url = "/animal_species";

export const useAnimalSpecies = ()=>{
    return useQuery(ajax_url, () => getPromise(prefix_url));
}